import { TMessageType } from '@api/Booking';
import Close from '@assets/close';
import Modal from '@components/Modal/Modal';
import Routes from '@constants/routes';
import {
  I18N_PROFILE_CONTEXT,
  SOLD_OUT_BUTTON_1,
  SOLD_OUT_BUTTON_2,
  SOLD_OUT_TEXT,
  SOLD_OUT_TITLE,
  SOLD_OUT_VIDEO,
  SOLD_OUT_VOICE,
} from '@features/profile/ProfileForm.constants';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { BottomSection, CloseIcon, Header, LightBg, ModalButton, SoldOutIcon, Text, TopSection } from './SoldOutModal.styles';
import { SoldOutModalType } from './SoldOutModal.types';

export const SoldOutModal = ({ display, creatorName, creatorSlug, messageType, onClose, onNotify }: SoldOutModalType): JSX.Element => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);

  const translationProps = () => ({
    celebrityName: creatorName,
    messageType:
      messageType === 'video' ? t(SOLD_OUT_VIDEO) : messageType === 'audio' ? t(SOLD_OUT_VOICE) : messageType === 'both' ? '' : '',
  });

  const onButtonOneClick = async () => {
    if (loading) return;
    setLoading(true);

    const messageTypes = messageType === 'audio' ? ['audio'] : messageType === 'video' ? ['video'] : ['audio', 'video'];
    await onNotify(messageTypes as TMessageType[]);
  };

  const onButtonTwoClick = async () => {
    if (loading) return;
    setLoading(true);

    const alternateMessageOption = messageType === 'audio' ? 'video' : 'audio';
    await router.push(Routes.BOOKING(creatorSlug, alternateMessageOption));
  };

  return (
    <Modal width={422} toDisplay={display}>
      <CloseIcon onClick={onClose}>
        <Close />
      </CloseIcon>
      <TopSection>
        <SoldOutIcon />
        <LightBg />
      </TopSection>
      <BottomSection>
        <Header>{t(SOLD_OUT_TITLE, translationProps())}</Header>
        <Text>{t(SOLD_OUT_TEXT(translationProps().messageType), translationProps())}</Text>
        <ModalButton onClick={onButtonOneClick} text={t(SOLD_OUT_BUTTON_1)} uppercase loadingState={loading} />
        {messageType !== 'both' && (
          <ModalButton
            uppercase
            variant='secondary'
            onClick={onButtonTwoClick}
            text={t(SOLD_OUT_BUTTON_2, { messageType: messageType === 'video' ? t(SOLD_OUT_VOICE) : t(SOLD_OUT_VIDEO) })}
            loadingState={loading}
          />
        )}
      </BottomSection>
    </Modal>
  );
};
